import { post, get } from '../../../../services/request';

//-------------------Raw Exam Data - start----------------//
// Get all raw exam data
export const getAllRawExamData = (payload) => {
    return post(`ExamData/GetAllRawExamDataWithPagination`, payload);
};